import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ExportToCsv } from 'export-to-csv';
import { DtpNoContent } from 'dtp-react-components';
import {
  Button,
} from '../../../components/index';
import {
  doGet,
} from '../../../utils/requests';
import * as listUtils from '../../../utils/listsSelect';
import { formatarCnpj } from '../../../utils/helpers';

class RelatorioControlePagamentos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showNoContent: false,
      noContentPrimaryMessage: null,
      noContentSecondaryMessage: null,
    };
  }

  tratarSucessoListaExportacao = (response) => {
    if (response.data !== '') {
      this.setState({
      }, this.gerarCsv(response.data, this.props.tipoControle));
    }
  };

  tratarErro = () => {
    const mensagemPrimaria = 'Não foi possível consultar os pagamentos.';
    const mensagemSecundaria = 'Contate o administrador do sistema.';
    this.setState({
      showNoContent: true,
      noContentPrimaryMessage: mensagemPrimaria,
      noContentSecondaryMessage: mensagemSecundaria,
    });
  };

colunasExportacaoPagador = [
  'CNPJ',
  'Participante',
  'Prazo Resposta',
  'Valor',
  'Estado',
  'Banco',
  'Número',
  'Conta corrente',
  'DV',
  'Agência',
  'DV',
]

colunasExportacaoRecebedor = [
  'CNPJ',
  'Participante',
  'Prazo Resposta',
  'Valor',
  'Estado',
]

colunasExportacaoDebitosPendentes = [
  'Competência',
  'Valor',
  'Data de Vencimento',
  'Estado',
]

colunasExportacaoPendencias = [
  'CNPJ',
  'Participante',
  'Competência',
  'Prazo Resposta',
  'Valor',
  'Data de Vencimento',
  'Estado',
]

defineHeaderParaExportacao = (tipoControle) => {
  let retorno = [];
  switch (tipoControle) {
    case 'controle-pagamentos':
      retorno = this.montaHeaderControlePagamentos();
      break;
    case 'controle-debitos-pendentes':
      retorno = this.montaHeaderDebitosPendentes();
      break;
    case 'pendencias':
      retorno = this.colunasExportacaoPendencias;
      break;
    default: retorno = [];
  }
  return retorno;
}

montaHeaderControlePagamentos = () => {
  let retorno = [];
  if (this.props.filtrosConsulta.visaoControlePagamento === 2) {
    retorno = this.colunasExportacaoPagador;
  } else {
    retorno = this.colunasExportacaoRecebedor;
  }
  return retorno;
}

montaHeaderDebitosPendentes = () => {
  let retorno = [];
  if (this.props.papelUsuarioLogado === 'analista-rgps' || this.props.filtrosConsulta.participanteObservador === '01000') {
    retorno.push(
      'CNPJ',
      'Participante',
    );
    retorno = retorno.concat(this.colunasExportacaoDebitosPendentes);
  } else {
    retorno = this.colunasExportacaoDebitosPendentes;
  }
  return retorno;
}

defineListaParaExportacao = (lista, tipoControle) => {
  const listaOriginal = lista;
  let resultado = [];
  switch (tipoControle) {
    case 'controle-pagamentos':
      resultado = this.montaColunasControlePagamentos(resultado, listaOriginal);
      break;
    case 'controle-debitos-pendentes':
      resultado = this.montaColunasDebitosPendentes(resultado, listaOriginal);
      break;
    case 'pendencias':
      resultado = this.montaColunasPendencias(resultado, listaOriginal);
      break;
    default: resultado = [];
  }
  return resultado;
};

montaColunasControlePagamentos = (resultado, listaOriginal) => {
  const visao = this.props.filtrosConsulta ? this.props.filtrosConsulta.visaoControlePagamento : 1;
  if (visao === 2) {
    listaOriginal.forEach((pagamento) => {
      resultado.push({
        cnpj: pagamento.cnpj ? formatarCnpj(pagamento.cnpj) : '',
        participante: pagamento.nomeEntidadeRecebedora ? pagamento.nomeEntidadeRecebedora : '',
        dataPrazo: pagamento.dataPrazo ? pagamento.dataPrazo : '',
        valor: this.formatarValorLabel(pagamento.valorCompensacao),
        estado: this.addTipoEstadoPagamentoCSV(pagamento.estado),
        nomeBanco: pagamento.nomeBanco ? pagamento.nomeBanco : '',
        numeroBanco: pagamento.codigoBanco ? pagamento.codigoBanco : '',
        numeroContaCorrente: pagamento.numeroContaCorrente ? pagamento.numeroContaCorrente : '',
        dvContaCorrente: pagamento.dvContaCorrente ? pagamento.dvContaCorrente : '',
        numeroAgencia: pagamento.numeroAgencia ? pagamento.numeroAgencia : '',
        dvAgencia: pagamento.dvAgencia ? pagamento.dvAgencia : '',
      });
    });
  } else {
    listaOriginal.forEach((pagamento) => {
      resultado.push({
        cnpj: pagamento.cnpjPagador ? formatarCnpj(pagamento.cnpjPagador) : '',
        participante: pagamento.nomeEntidadePagadora ? pagamento.nomeEntidadePagadora : '',
        dataPrazo: pagamento.dataPrazo ? pagamento.dataPrazo : '',
        valor: this.formatarValorLabel(pagamento.valorCompensacao),
        estado: this.addTipoEstadoPagamentoCSV(pagamento.estado),
      });
    });
  }
  return resultado;
}

montaColunasDebitosPendentes = (resultado, listaOriginal) => {
  let colunas = {};
  let resultadoColunas = resultado;
  listaOriginal.forEach((pagamento) => {
    if (this.props.papelUsuarioLogado === 'analista-rgps' || this.props.filtrosConsulta.participanteObservador === '01000') {
      colunas = {
        cnpj: pagamento.cnpjPagador ? formatarCnpj(pagamento.cnpjPagador) : '',
        participante: pagamento.nomeEntidadePagadora ? pagamento.nomeEntidadePagadora : '',
      };
    }
    const colunasDefault = {
      competencia: this.formatarCompetencia(pagamento.mes, pagamento.ano),
      valor: this.formatarValorLabel(pagamento.valorCompensacao),
      dataDeVencimento: pagamento.dataVencimento ? pagamento.dataVencimento : '',
      estado: this.addTipoEstadoPagamentoCSV(pagamento.estado),
    };
    colunas = { ...colunas, ...colunasDefault };
    resultadoColunas = resultadoColunas.concat(colunas);
  });
  return resultadoColunas;
}

montaColunasPendencias = (resultado, listaOriginal) => {
  const visao = this.props.filtrosConsulta ? this.props.filtrosConsulta.visaoControlePagamento : '';
  let colunas = {};
  let resultadoColunas = resultado;
  listaOriginal.forEach((pagamento) => {
    if (visao === 1) {
      colunas = {
        cnpj: pagamento.cnpjPagador ? formatarCnpj(pagamento.cnpjPagador) : '',
      };
    } else {
      colunas = {
        cnpj: pagamento.cnpj ? formatarCnpj(pagamento.cnpj) : '',
      };
    }
    const colunasDefault = {
      participante: visao === 1 ? pagamento.nomeEntidadePagadora : pagamento.nomeEntidadeRecebedora,
      competencia: this.formatarCompetencia(pagamento.mes, pagamento.ano),
      dataPrazo: pagamento.dataPrazo ? pagamento.dataPrazo : '',
      valor: this.formatarValorLabel(pagamento.valorCompensacao),
      dataDeVencimento: pagamento.dataVencimento ? pagamento.dataVencimento : '',
      estado: this.addTipoEstadoPagamentoCSV(pagamento.estado),
    };
    colunas = { ...colunas, ...colunasDefault };
    resultadoColunas = resultadoColunas.concat(colunas);
  });
  return resultadoColunas;
}

formatarCompetencia = (mes, ano) => {
  let objCompetencia = '';
  if (mes !== '0' && ano !== '0') {
    objCompetencia = `${mes}/${ano}`;
    if (objCompetencia.length !== 7) {
      objCompetencia = `0${objCompetencia}`;
    }
  }
  return objCompetencia;
};

formatarValorLabel = (valorCompensacao) => {
  let valorFormatado = '';
  if (valorCompensacao) {
    valorFormatado = valorCompensacao.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 3 });
  }
  return valorFormatado;
};

addTipoEstadoPagamentoCSV = tipo => (
  listUtils.getObject(listUtils.estadosPagamento, tipo).label
);

addVisaoCSV = tipo => (
  listUtils.getObject(listUtils.visoesControlePagamento, tipo).label
);


exportar = () => {
  if (Object.entries(this.props.filtrosConsulta).length !== 0) {
    doGet(
      'controle-pagamentos/exportacao-csv',
      this.tratarSucessoListaExportacao,
      this.tratarErro,
      {
        ...this.props.filtrosConsulta,
      },
    );
  }
};

gerarCsv = (json, tipoControle) => {
  let dadosRelatorio = null;
  let legenda = '';
  let retorno = [];

  switch (tipoControle) {
    case 'controle-pagamentos':
      legenda = `Controle de pagamentos - ${this.props.filtrosConsulta.competencia} - ${this.addVisaoCSV(this.props.filtrosConsulta.visaoControlePagamento)}`;
      retorno = json;
      break;
    case 'controle-debitos-pendentes':
      legenda = `Controle de débitos carregados RGPS ${this.props.tituloTabela}`;
      retorno = json.pagamentos;
      break;
    case 'pendencias':
      legenda = `Pendencias de controle de pagamentos ${this.props.tituloTabela}`;
      retorno = json;
      break;
    default: legenda = '';
  }

  if (retorno && retorno !== undefined && retorno.length > 0) {
    dadosRelatorio = this.defineListaParaExportacao(retorno, tipoControle);
  } else {
    dadosRelatorio = [];
  }


  if (dadosRelatorio && dadosRelatorio !== undefined && dadosRelatorio.length > 0) {
    const csvExporter = new ExportToCsv({
      // filename: this.props.tipoControle === 'controle-pagamentos' ? 'Controle de Pagamentos' : 'Controle de Débitos Pendentes',
      filename: this.defineNomeArquivoExportacao(this.props.tipoControle),
      fieldSeparator: ';',
      showTitle: true,
      title: legenda,
      showLabels: true,
      headers: this.defineHeaderParaExportacao(tipoControle),
    });
    csvExporter.generateCsv(dadosRelatorio);
  }
}

defineNomeArquivoExportacao = (tipoControle) => {
  let retorno = '';
  switch (tipoControle) {
    case 'controle-pagamentos':
      retorno = 'Controle de Pagamentos';
      break;
    case 'controle-debitos-pendentes':
      retorno = 'Controle de Débitos Carregados RGPS';
      break;
    case 'pendencias':
      retorno = 'Pendências de Controle de Pagamento';
      break;
    default: retorno = '';
  }
  return retorno;
}

render() {
  if (this.state.showNoContent) {
    return (
      <DtpNoContent
        primaryText={this.state.noContentPrimaryMessage}
        secondaryText={this.state.noContentSecondaryMessage}
        show={this.state.showNoContent}
      />);
  }
  return (
    <React.Fragment>
      <div className="row">
        <Button
          hint="Exportar para CSV"
          onClick={() => { this.exportar(); }}
          icon="ico-doc-sheet"
          mini
        />
      </div>
    </React.Fragment>
  );
}
}

RelatorioControlePagamentos.propTypes = {
  voltarAction: PropTypes.func,
  filtrosConsulta: PropTypes.object,
  tipoControle: PropTypes.string,
  papelUsuarioLogado: PropTypes.string,
  tituloTabela: PropTypes.string,
}.isRequired;

RelatorioControlePagamentos.defaultProps = {
  voltarAction: () => null,
};

export default RelatorioControlePagamentos;



// WEBPACK FOOTER //
// ./src/pages/controle-pagamento/templates/RelatorioControlePagamentos.jsx